import Vue from 'vue';

import Api from '../../plugins/Api.js';
Vue.use(Api);

const state = {
    user: {},
    activeRoute: '',
    is_authenticated: false,
    company: {},
    companies:[],
    activeNav: '',
    auth_token: '',
    userRoles:[]
};

const getters = {
    getUserData(state){
        return state.user;
    },
    getUserRoles(state){
      //return state.userRoles;
      var roleObj = {};
      state.userRoles.forEach(function(role){
        roleObj[role.role_id] = {
          name: role.name,
          rolesPermissions:{}
        };

        role.rolesPermissions.forEach(function(p){
          roleObj[role.role_id].rolesPermissions[p.rolePermission_id] = {
            name: p.name,
            state: p.state
          }
        })
      });
      return roleObj;
    },

    getToken(state) {
      return state.auth_token;
    },
    hasPermission(state){
      var any = false;
      return state.userRoles.filter(function(role){

        var permissions = Object.keys(state.activeRoute.meta.permissions);
        if(permissions.indexOf(role.name) > -1){
          var permitted = state.activeRoute.meta.permissions[role.name];

          if(permitted[0] == "*") any = true;

          return role.rolesPermissions.filter(function(r){
            if(any) return r.state;
            if(permitted.indexOf(r.name) > -1 ) {
              return r.state;
            }
            return false
          }).length;
        }
        return false;
      }).length;
    },
    checkAuth(state){
      return state.is_authenticated;
    }
};


const mutations = {
    activeRoute(state, payload){
      state.activeRoute = payload;
    },
    authenticate (state, payload) {
        state.is_authenticated = payload.is_authenticated;
        state.auth_token = payload.auth_token;
        localStorage.setItem('auth_token', payload.auth_token);
    },
    updateAuth() {
        var jwt = localStorage.getItem('auth_token');
        if(jwt) {
            state.auth_token = jwt;
            state.is_authenticated = true
        }
        else {
            state.is_authenticated = false
        }
    },
    setUserData(state, payload){
        state.userRoles = payload.userRoles;
        state.user = payload.userDetails;
    },
    setCompanyData(state, payload){
        state.company = payload.company;
    }
};

const actions = {
    logout(context) {
        localStorage.removeItem('auth_token');
        context.commit('updateAuth');
        return;
    },
    setRoles (context, payload) {
      return new Promise((resolve, reject) => {
        Vue.http.post('https://api.trackcommissions.com:444', {
          function: 'userRoles'
        }, {
          emulateJSON: true
        }).then(function(response){

          if(response.body.status){
            context.commit('setUserData', {
                userRoles: response.body.data.userRoles,
                userDetails: response.body.data.userDetails
            });

            resolve();
          }
        });

       
      })
    }
};

export default {
    state,
    mutations,
    actions,
    getters
}



// WEBPACK FOOTER //
// ./src/store/modules/authentication.js